<template>
	<div id="center">
		<div id="sb" style="height:6rem;padding:0.1rem"></div>
	</div>
</template>

<script>
	import echartMixins from "@/utils/resizeMixins";
	// 显示中国地图

	export default {
		data() {
			return {
				chart: null,
			};
		},
		props: {
			sersor: Array,
			dian: Array
		},
		mixins: [echartMixins],
		mounted() {
			this.draw();
		},
		methods: {
			draw() {
				// 基于准备好的dom，初始化echarts实例

				this.chart = this.$echarts.init(document.getElementById("sb"));
				var option = {
					tooltip: {},
					series: [{
						type: 'graph',
						layout: 'force', // 使用力导向图布局，也可以用 'circular'、'force' 等布局
						symbolSize: 40, // 节点的大小
						roam: true, // 是否开启鼠标缩放和平移漫游。默认不开启。如果只想要开启缩放或者平移，可以设置成 'scale' 或者 'move'。设置成 true 为都开启
						label: {
							show: true
						},
						edgeSymbol: ['rect', 'arrow'], // 边的两端标记类型，可以设置不同的标记类型，例如箭头等。
						edgeSymbolSize: [4, 10], // 边的两端标记的大小
						edgeLabel: {
							fontSize: 10
						},
						force: {
							repulsion: 200, //相距距离
							edgeLength: [80, 150],
							layoutAnimation: true
						},
						data: this.sersor,
						// 边列表
						links: this.dian,
						lineStyle: {
							normal: {
								color: '#31354B',
								width: '1',
								type: 'dashed', //线的类型 'solid'（实线）'dashed'（虚线）'dotted'（点线）
								curveness: 0,
								opacity: 1 //图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形。默认0.5
							}
						}
					}]
				};

				this.chart.setOption(option);
			}
		},
		destroyed() {
			window.onresize = null;
		}
	};
</script>

<style lang="scss">


</style>